export const SHARED = 'shared'
export const STANDALONE = 'standalone'

export const NODE_ENV_TEST = 'test'
